<template>
    <div class="el-tooltip command-button"  @click="dialogSetAppoint = true">
        <el-tooltip  effect="dark" :content="$t('titleEditor.QuoteTheAnswerFromThePreviousQuestion')" placement="top">
            <span style="display: inline-block;font-size: 12px;width:22px !important; font-weight: bold;white-space: nowrap;">{{$t('titleEditor.introduce')}}</span>
        <!-- <i class="el-icon-edit-outline" ></i> -->
        </el-tooltip>

        <!-- 引用弹窗 -->
        <el-dialog
        :append-to-body="true"
        class="logical-setAppoint"
        :title="$t('titleEditor.quote')"
        :visible.sync="dialogSetAppoint"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="30%">
        <el-form ref="form" label-position="top" :model="setAppointForm" label-width="80px">
            <el-form-item :label="`${$t('titleEditor.CiteTheAnswersToThePreviousQuestionsToTheFollowingText')}:`">
            <el-select 
                :no-data-text="$t('titleEditor.ThereAreCurrentlyNoTestQuestionsToCite')" 
                size="small" 
                v-model="appointQuesSetAppoint" 
                :placeholder="$t('titleEditor.PleaseSelectTheTestQuestion')"
            >
                <el-option 
                v-for="item in list"
                :key="item.qid"
                :label="item.questionsName" 
                :value="item.qid"
                ></el-option>
            </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogSetAppoint = false">{{$t('main.cancel2')}}</el-button>
            <el-button size="medium" type="primary" @click="doSetAppoint">{{$t('main.ok2')}}</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    // 自定义高级编辑组件
    name: "advancedEditingBtn",
    data() {
        return {
            dialogSetAppoint: false,
            setAppointForm: {},
            appointQuesSetAppoint: '',
            list: []
        }
    },
    computed:{
        ...mapState(['citableQuesList']),
    },
    watch: {
        citableQuesList(newV) {
            this.list = JSON.parse(newV)
        }
    },
    created() {
        if (this.$functions.isJSON(this.citableQuesList)) {
            this.list = JSON.parse(this.citableQuesList)
        } else {
            this.list = this.citableQuesList
        }
    },
    methods: {
        // 
        doSetAppoint() {
            let questionNum = ''
            this.dialogSetAppoint = false
            let quesIndex = 0
            this.list.forEach((info) =>{
              if (info.qid == this.appointQuesSetAppoint) {
                quesIndex = info.quesIndex
              }
            })
            console.log(`${this.$t('main.QuestionNumber')}：${quesIndex}`)
            questionNum = `[Q${quesIndex + 1}]`
            this.$emit("click", questionNum);
        }
    }
};
</script>

<style lang="scss" scoped>
.el-icon-edit-outline{
    font-weight: bold !important;
}
.command-button{
    border: 1px solid transparent;
    box-sizing: border-box;
    align-items: center;
    border-radius: 50%;
    color: #303133;
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 40px;
    margin: 2px;
    outline: 0;
    transition: all .2s ease-in-out;
    width: 27px !important;
    height: 18px !important;
}
</style>